import $ from 'jquery';
window.$ = window.jQuery = $;



require('../node_modules/jquery/dist/jquery.js');
// require('../node_modules/device/lib/device.js');
require('../node_modules/owl.carousel/dist/owl.carousel');
require('../node_modules/magnific-popup/dist/jquery.magnific-popup.min.js');
require('../node_modules/blueimp-gallery/js/blueimp-gallery.min.js');

import main from "./components/main";

document.addEventListener("DOMContentLoaded", async () => {
    main();
});
